import { render, staticRenderFns } from "./QuestionPanel.vue?vue&type=template&id=adf64d36"
import script from "./QuestionPanel.vue?vue&type=script&lang=js"
export * from "./QuestionPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports